/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AcceptInvite200,
  AcceptInviteBody,
  ForgotPassword200,
  ForgotPasswordBody,
  Register200,
  RegisterRequest,
  ResetPassword200,
  ResetPasswordBody,
  VerifyEmail200,
  VerifyEmailBody
} from '.././models';

import { apiClient } from '../../client';




/**
 * @summary Verify email via the one-time link sent after registration
 */
export const verifyEmail = (
    verifyEmailBody: VerifyEmailBody,
 signal?: AbortSignal
) => {
      
      
      return apiClient<VerifyEmail200>(
      {url: `/api/v1/auth/verify-email`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: verifyEmailBody, signal
    },
      );
    }
  


export const getVerifyEmailMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,{data: VerifyEmailBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,{data: VerifyEmailBody}, TContext> => {

const mutationKey = ['verifyEmail'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof verifyEmail>>, {data: VerifyEmailBody}> = (props) => {
          const {data} = props ?? {};

          return  verifyEmail(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type VerifyEmailMutationResult = NonNullable<Awaited<ReturnType<typeof verifyEmail>>>
    export type VerifyEmailMutationBody = VerifyEmailBody
    export type VerifyEmailMutationError = unknown

    /**
 * @summary Verify email via the one-time link sent after registration
 */
export const useVerifyEmail = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof verifyEmail>>, TError,{data: VerifyEmailBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof verifyEmail>>,
        TError,
        {data: VerifyEmailBody},
        TContext
      > => {

      const mutationOptions = getVerifyEmailMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Set a new password via the forgot-password email link
 */
export const resetPassword = (
    resetPasswordBody: ResetPasswordBody,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ResetPassword200>(
      {url: `/api/v1/auth/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: resetPasswordBody, signal
    },
      );
    }
  


export const getResetPasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext> => {

const mutationKey = ['resetPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetPassword>>, {data: ResetPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  resetPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof resetPassword>>>
    export type ResetPasswordMutationBody = ResetPasswordBody
    export type ResetPasswordMutationError = unknown

    /**
 * @summary Set a new password via the forgot-password email link
 */
export const useResetPassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetPassword>>, TError,{data: ResetPasswordBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetPassword>>,
        TError,
        {data: ResetPasswordBody},
        TContext
      > => {

      const mutationOptions = getResetPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Register a new organisation with its first (ORGANISATION_ADMIN) user
 */
export const register = (
    registerRequest: RegisterRequest,
 signal?: AbortSignal
) => {
      
      
      return apiClient<Register200>(
      {url: `/api/v1/auth/register`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: registerRequest, signal
    },
      );
    }
  


export const getRegisterMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: RegisterRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: RegisterRequest}, TContext> => {

const mutationKey = ['register'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof register>>, {data: RegisterRequest}> = (props) => {
          const {data} = props ?? {};

          return  register(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type RegisterMutationResult = NonNullable<Awaited<ReturnType<typeof register>>>
    export type RegisterMutationBody = RegisterRequest
    export type RegisterMutationError = unknown

    /**
 * @summary Register a new organisation with its first (ORGANISATION_ADMIN) user
 */
export const useRegister = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof register>>, TError,{data: RegisterRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof register>>,
        TError,
        {data: RegisterRequest},
        TContext
      > => {

      const mutationOptions = getRegisterMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Request a password-reset email
 */
export const forgotPassword = (
    forgotPasswordBody: ForgotPasswordBody,
 signal?: AbortSignal
) => {
      
      
      return apiClient<ForgotPassword200>(
      {url: `/api/v1/auth/forgot-password`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: forgotPasswordBody, signal
    },
      );
    }
  


export const getForgotPasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordBody}, TContext> => {

const mutationKey = ['forgotPassword'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof forgotPassword>>, {data: ForgotPasswordBody}> = (props) => {
          const {data} = props ?? {};

          return  forgotPassword(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ForgotPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof forgotPassword>>>
    export type ForgotPasswordMutationBody = ForgotPasswordBody
    export type ForgotPasswordMutationError = unknown

    /**
 * @summary Request a password-reset email
 */
export const useForgotPassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof forgotPassword>>, TError,{data: ForgotPasswordBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof forgotPassword>>,
        TError,
        {data: ForgotPasswordBody},
        TContext
      > => {

      const mutationOptions = getForgotPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Set initial password via the invite email link
 */
export const acceptInvite = (
    acceptInviteBody: AcceptInviteBody,
 signal?: AbortSignal
) => {
      
      
      return apiClient<AcceptInvite200>(
      {url: `/api/v1/auth/accept-invite`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: acceptInviteBody, signal
    },
      );
    }
  


export const getAcceptInviteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{data: AcceptInviteBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{data: AcceptInviteBody}, TContext> => {

const mutationKey = ['acceptInvite'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptInvite>>, {data: AcceptInviteBody}> = (props) => {
          const {data} = props ?? {};

          return  acceptInvite(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptInviteMutationResult = NonNullable<Awaited<ReturnType<typeof acceptInvite>>>
    export type AcceptInviteMutationBody = AcceptInviteBody
    export type AcceptInviteMutationError = unknown

    /**
 * @summary Set initial password via the invite email link
 */
export const useAcceptInvite = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptInvite>>, TError,{data: AcceptInviteBody}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptInvite>>,
        TError,
        {data: AcceptInviteBody},
        TContext
      > => {

      const mutationOptions = getAcceptInviteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    